export default __webpack_public_path__ + "static/media/logo.eb79a49a.png";